module.exports = __webpack_public_path__ + "img/PT2140.a7fceb78.png";